import React, {Fragment, memo} from 'react';
import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import dynamic from 'next/dynamic';
const DisplayImage = dynamic(import('@/components/Ui-components/display-image'), {ssr: false});
import {colors, fontFamily, fontWeight, spacing} from '@/styles/tokens';

// `height: 180px` was previously a `.tech-label-wrapper .tech_label` nested
// override in globals.scss — folded in directly since `.tech-label-wrapper`
// (kept as a classname below for TabTechnology's sake, see its own report)
// is unconditionally this element's parent in this component's own markup.
const sxTechLabel = {
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px', // no exact token match
    textAlign: 'center',
    padding: spacing[20],
    minHeight: '150px', // no exact spacing-token match
    height: '180px', // no exact spacing-token match
    display: 'flex',
    flexDirection: 'column',
    placeContent: 'center'
};

// Migrated from globals.scss `.label` (bare, generically-named class). Sole owner confirmed —
// re-grepped the entire repo for standalone `label` classNames (literal strings, template
// literals, clsx/classNames calls); this component's own `<MUITypography className="label">`
// below is the only real consumer.
const sxLabel = {
    fontFamily: `${fontFamily.body} !important`,
    fontSize: '16px !important', // no exact token match — fontSize[16] is '1rem', not '16px', preserved for parity
    fontWeight: `${fontWeight.regular} !important`,
    color: colors.text.primary
} as const;

const HealthcareSector = (props: any) => {
    const {heading, subheading, healthcareData, postion} = props;
    return (
        <MUIBox>
            <MUIBox className="spectrum-header-wrapper solutions">
                <MUITypography className="spectrum-heading color-black">{heading}</MUITypography>
                <MUIBox className="divder-wrapper">
                    <hr className="divider-line" />
                </MUIBox>
                <MUIBox className="sub-heading-box" pb={3.8}>
                    <MUITypography className="spectrum-sub-heading color-black spacing">{subheading}</MUITypography>
                </MUIBox>
            </MUIBox>

            <MUIGrid container spacing={3} justifyContent={postion === 'center' ? 'center' : 'initial'}>
                {healthcareData?.map((data: any, index: number) => (
                    <Fragment key={index}>
                        <MUIGrid item xs={12} sm={6} md={3} lg={3} className="tech-label-wrapper">
                            {/* <Link href={data && data.redirect} className="menu-links"> */}
                            <MUIBox sx={sxTechLabel}>
                                <MUIBox>
                                    <DisplayImage src={data.src} alt={data.label} priority={false} className="step-image" />
                                </MUIBox>
                                <MUIBox>
                                    <MUITypography className="label" sx={sxLabel}>
                                        {data.label}{' '}
                                    </MUITypography>
                                </MUIBox>
                            </MUIBox>
                            {/* </Link> */}
                        </MUIGrid>
                    </Fragment>
                ))}
            </MUIGrid>
        </MUIBox>
    );
};

export default memo(HealthcareSector);
